<template>
  <div>
    <div id="categorydiv">{{ catname }}</div>
    <div v-for="product in products" v-bind:key="product.id">
      <div id='proditem'>
        <div id='prodname'>{{ product.productname }}</div>
        <div id='description'>{{ product.description }}</div>
        <div id='price'>€ {{ product.price }}</div>
        <img id='image' :src="$options.filters.removetilde(product.picture)">
        <router-link class="button" style="text-decoration: none; color:inherit;" :to="{ path: '/DeleteProduct', query: { Id: product.id, ProdName: product.productname  } }">
            Delete
        </router-link>
        <router-link class="button" style="text-decoration: none; color:inherit;" :to="{ path: '/ProductDetails', query: { Id: product.id, ProdName: product.productname } }">
            Details
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Comp_ShowProducts',
    props: ['products', 'catname','showheader'],
    data() {
      return {

      }
    },
    methods: {

    },
    filters: {
      removetilde: function (string) {
        var firstChar = string.charAt(0);
        if (firstChar == '~') {
          return string.substring(1, string.length);
        }
        else {
          return string;
        }
      }
    },
    computed: {

    }
  }
</script>

<style scoped>
  #prodname, #description, #price, #image {
    display: inline-block;
    vertical-align: top;
    margin-top: 10px;
  }

  #proditem {
    margin-left: 20px;
    margin-bottom: 20px;
    border-top: 1px solid lightgray;
  }

  #prodname {
    width: 200px;
  }

  #description {
    width: 300px;
  }

  #price {
    width: 100px;
  }

  #image {
    width: 250px;
  }

  #categorydiv {
    margin-left: 20px;
    font-family: Arial;
    font-size: 20px;
    margin-bottom: 40px;
  }

  .button {
    border: 1px solid gray;
    border-radius: 4px;
    padding: 10px;
    display: inline-block;
    margin-top:10px;
  }
</style>



// WEBPACK FOOTER //
// src/Comp_ShowProducts.vue